
$(document).on("change", ".new-only-colors-inp", function(){
  let val = $(this).val();
  $(`.new-options-wrapper:not(.updated) .new-options--colors .new-options-variants-inp[value="${val}"]`).trigger("click");
  if($(this).next(".new-only-colors-label").find("span").attr("data-img") != undefined){
    if($('[data-media-position="1"]').length > 0){
      $('[data-media-position="1"]').find("img").removeAttr("srcset");
      $('[data-media-position="1"]').find("img").attr("src", $(this).next(".new-only-colors-label").find("span").attr("data-img") + '&width=300');
    }
    if($(".product__media-item").length > 0){
      $(".product__media-item").eq(0).find("img").removeAttr("srcset");
      $(".product__media-item").eq(0).find("img").attr("src", $(this).next(".new-only-colors-label").find("span").attr("data-img"));
    }
    resetSliderToFirstSlide();
  }
})

function resetSliderToFirstSlide() {
  var $section = $('.product__media-wrapper');
  $section.find('.slider').each(function () {
    this.scrollTo({ left: 0, behavior: 'smooth' });
  });
  $section.find('.thumbnail-list').each(function () {
    this.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  });
}

$(document).on("click", ".new-options-add-btn", function(){
  $(this).removeClass("active");
  let parent = $(this).parents(".new-options-wrapper");
  parent.addClass("active");
  parent.find(".new-options-cancel-btn").addClass("active");
  parent.find(".new-options-variants-main-wrapper").addClass("active");
  updateVariants();
})

$(document).on("click", ".new-options-cancel-btn", function(){
  $(this).removeClass("active");
  let parent = $(this).parents(".new-options-wrapper");
  parent.removeClass("active");
  parent.removeClass("updated");
  parent.find(".new-options-add-btn").addClass("active");
  parent.find(".new-options-variants-main-wrapper").removeClass("active");
  parent.find(".new-options-change-wrapper").removeClass("active");
  updateVariants();
})

$(document).on("click", ".new-options-qty-plus", function(){
  let parent = $(this).parents(".new-options-wrapper");
  parent.find(".new-options-qty-inp")[0].stepUp(1);
  parent.find(".new-options-qty-inp")[1].stepUp(1);
  parent.find(".new-options-qty-minus").removeClass("new-options-qty-disabled");
  updateVariants();
})

$(document).on("click", ".new-options-qty-minus", function(){
  let parent = $(this).parents(".new-options-wrapper");
  parent.find(".new-options-qty-inp")[0].stepDown(1);
  parent.find(".new-options-qty-inp")[1].stepDown(1);
  if(parent.find(".new-options-qty-inp").eq(0).val() <= 1){
    parent.find(".new-options-qty-minus").addClass("new-options-qty-disabled");
  }
  updateVariants();
})

$(document).on("click", ".new-options-colors-update", function(){
  let parent = $(this).parents(".new-options-variants-container");
  parent.toggleClass("active");
  parent.find(".new-options-variants-wrapper").toggleClass("active");
})

$(document).on("change", ".new-options-variants-inp", function(){
  let parent = $(this).parents(".new-options-variants-container");
  parent.find(".new-options-variants-selected em").text($(this).val());
  updateVariants();
})

$(document).on("click", ".new-options-updates-btn", function(){
  let parent = $(this).parents(".new-options-wrapper");
  parent.addClass("updated");
  parent.find(".new-options-variants-main-wrapper").removeClass("active");
  parent.find(".new-options-change-wrapper").addClass("active");
})

$(document).on("click", ".new-options-change-btn", function(){
  let parent = $(this).parents(".new-options-wrapper");
  parent.removeClass("updated");
  parent.find(".new-options-variants-main-wrapper").addClass("active");
  parent.find(".new-options-change-wrapper").removeClass("active");
})

function updateVariants(){
  let compare_price = 0;
  let price = 0;
  let ids = '';
  if($(".new-options-wrapper.active").length > 0){
    let oneSold = false;
    $(".new-options-wrapper.active").each(function(){
      let $this = $(this);
      let comb = '';
      if($this.parents(".new-options-container-meta").length <= 0){
        comb = $(this).find(".new-options-title").text() + " / ";
      }
      $(this).find(".new-options-variants-inp:checked").each(function(){
        comb += $(this).val() + " / ";
        if($(this).parents(".new-options-variants-container").hasClass("new-options--colors")){
          $this.find(".new-options-change-selected em.new-options-change-selected-color em").text($(this).val());
          $this.find(".new-options-change-selected em.new-options-change-selected-color").attr("style", `color: ${$(this).attr("data-color")}`);
        }
        else{
          $this.find(".new-options-change-selected em:not(.new-options-change-selected-color) em").text($(this).val());
        }
      })
      comb = comb.substring(0, comb.length - 2).trim();
      let master = ''
      if($this.parents(".new-options-container-meta").length > 0){
        master = $this.parents(".new-options-container-meta").find(`.new-options-master-li[data-title="${comb}"]`);
      }
      else{
        master = $(`.new-options-master-li[data-title="${comb}"]`);
      }
      $this.find(".new-options-updates-btn").removeClass("sold");
      if(master.attr("data-sold") == "sold"){
        oneSold = true;
        $this.find(".new-options-updates-btn").addClass("sold");
        $(".new-options-atc-btn").removeClass("active");
        $(".new-options-atc-btn").addClass("sold");
        $(".new-options-atc-price").html('');
      }
      else{
        $(".new-options-atc-btn").removeClass("sold");
        $(".new-options-atc-btn").addClass("active");
        let quantity = parseInt($(this).find(".new-options-qty-inp").eq(0).val());
        compare_price += parseFloat(master.attr("data-cp")) * quantity;
        price += parseFloat(master.attr("data-p")) * quantity;
        $(".new-options-atc-price").html(`<strike>$${compare_price.toFixed(2)}</strike> <span>$${price.toFixed(2)}</span>`);
        ids += `${master.attr("data-id")}:${quantity},`;
      }
      $(this).find(".new-options-price").html(master.attr("data-price"));
      $(".new-options-atc-btn").attr("data-ids", ids);
    })
    if(oneSold){
      $(".new-options-atc-btn").removeClass("active");
      $(".new-options-atc-btn").addClass("sold");
    }
  }
  else{
    $(".new-options-atc-btn").removeClass("active");
    $(".new-options-atc-btn").removeClass("sold");
    $(".new-options-atc-price").html('');
  }
}

$(document).on("click", ".new-options-atc-btn", function(){
  let arr = [];
  let ids = $(this).attr("data-ids").split(",");
  for (item of ids){
    if(item != ''){
      let vid = item.split(":")[0];
      let qty = parseInt(item.split(":")[1]);
      arr.push({ 'id': vid, 'quantity': qty });
    }
  }
  AddProdToCart(arr, $(this));
})

function AddProdToCart(productsArr, $this, open=true){
  $this.addClass("load");
  let formData = {
    'items': productsArr,
    sections: "cart-drawer,cart-icon-bubble"
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
      if (typeof window.opusOpen === "function") {
         window.opusOpen();
        return;
      }
      if(open){
        document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
        $(".cart-count-bubble").trigger("click");
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    $this.removeClass("load");
  });
}
